module.exports = __webpack_public_path__ + "static/media/Pidgeotto_gaussian2.291ebdbf.png";